import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  freeTrialCaption: {
    lineHeight: 1,
  },
  text: {
    display: "flex",
    flexDirection: "column",
    color: `${theme.palette.text.primary} !important`,
  },
}));
